import React, {Fragment} from "react";
import DataTableBase from "../../../../../ui/data_tables/DataTableBase";
import localeInfo from "../../../../../ui/pagination/PaginationLocalInfo";
import classNames from "classnames";

import '../../../../../../assets/sass/pages/scouting/scouting-datatable.scss';
import 'rc-pagination/assets/index.css';

class ScoutingDatatable extends DataTableBase {

    showPagination = this.props.showPagination ?? true;
    /**
     * Returns the table columns configurations.
     * @returns {{dataField: string, text: string, headerTitle: string, sort :boolean}[]} .
     * dataField: the dataField.
     * text: The column display name.
     * sort: Determine if column is sortable.
     * headerTitle:
     */
    columnsConfig = () => {
        return [
            {
                dataField: 'player',
                text: 'Player',
                renderer: this.renderPlayer,
            }, {
                dataField: 'playing_position',
                text: 'Playing Position',
            }, {
                dataField: 'manager_agent',
                text: 'Manager / Agent',
            }, {
                dataField: 'country',
                text: 'Country',
            }, {
                dataField: 'team_club',
                text: 'Team / Club',
            }, {
                dataField: 'report_date',
                text: 'Report Date',
            },{
                dataField: 'buttons_scouting-cell',
                text: '',
                renderer: this.renderButtonsScouting
            }
        ]
    };

    /**
     * Render table component.
     * @returns {React.ReactNode} The table component.
     */
    renderTable = () => {
        const pagination = this.showPagination ? "has-pagination" : "";

        return (
            <div className={classNames("main-table", "datatable-base", pagination, this.extraClasses.table)}>
                {this.renderHeader()}
                {this.wrapBodyWithinScrollbar(this.renderBody())}
            </div>
        );
    };

    renderPlayer = (rowData, dataField) => {
        const { player, avatar } = rowData;

        return (
            <div className="player--cell">
                <img src={avatar} alt=""/>
                <span>{player}</span>
            </div>
        );
    };

    selectRowConfig = () => {
        return {
            enable: true,
            mode: 'checkbox',
            hideSelectAll: false,
            clickToExpand: false,
            clickToSelect: true,
            selectionRenderer: this.renderSelectRowIcon,
            selectionHeaderRenderer: this.renderSelectHeaderIcon,
        };
    };

    expandRowConfig = () => {
        return {
            enable: false,
        };
    };

    paginationConfig = () => {
        const options = [10, 20, 30, 50].map(item => {
            return {value: item, label: item}
        });
        const defaultOption = options[3];

        return {
            enable: this.showPagination,
            defaultCurrentPage: 1,
            pageSizeOptions: options,
            defaultOption: defaultOption,
            showRowsText: "Show Rows",
            goText: "Go",
            localeInfo: localeInfo,
        }
    };

    /**
     * Extra classes for datatable.
     * @type {{table: string}} The extra classes.
     */
    extraClasses = {
        table: 'scouting-datatable',
    };

    static defaultProps = {
        enableSelect: true
    };
}

export default ScoutingDatatable;
